export const monasteryCoordinates = [
  { name: "Rumtek Monastery", latitude: 27.3539, longitude: 88.6207 },
  { name: "Pemayangtse Monastery", latitude: 27.2051, longitude: 88.2134 },
  { name: "Tashiding Monastery", latitude: 27.3372, longitude: 88.2714 },
  { name: "Dubdi Monastery", latitude: 27.3667, longitude: 88.2167 },
  { name: "Ralang Monastery", latitude: 27.2833, longitude: 88.5500 },
  { name: "Kathog Lake Monastery", latitude: 27.3667, longitude: 88.2333 },
  { name: "Lingdum Zurmang Monastery", latitude: 27.2833, longitude: 88.5167 },
  { name: "Bumtar Namdroling Monastery", latitude: 27.3000, longitude: 88.6000 },
  { name: "Doling Monastery", latitude: 27.2300, longitude: 88.4200 },
  { name: "Karma Raptenling Monastery", latitude: 27.2500, longitude: 88.4100 },
  { name: "Ngadag Monastery", latitude: 27.2400, longitude: 88.4300 },
  { name: "Aden Wolung Monastery", latitude: 27.2800, longitude: 88.1800 },
  { name: "Chakung Monastery", latitude: 27.2600, longitude: 88.1600 },
  { name: "Dodak Tamu Monastery", latitude: 27.3100, longitude: 88.1900 },
  { name: "Druk Monastery", latitude: 27.2900, longitude: 88.2100 },
  { name: "Hungri Monastery", latitude: 27.2700, longitude: 88.1700 },
  { name: "Khachoedpalri Monastery", latitude: 27.3200, longitude: 88.1500 },
  { name: "Lhuntse Monastery", latitude: 27.2500, longitude: 88.1400 },
  { name: "Melli-Atsing Monastery", latitude: 27.2400, longitude: 88.1300 },
  { name: "Nubling Monastery", latitude: 27.2200, longitude: 88.1200 },
  { name: "Okhery Monastery", latitude: 27.3300, longitude: 88.2000 },
  { name: "Pegmantysse Monastery", latitude: 27.2300, longitude: 88.1100 },
  { name: "Rinchen Choling Monastery", latitude: 27.2600, longitude: 88.1800 },
  { name: "Rinchenpung Monastery", latitude: 27.2800, longitude: 88.1900 },
  { name: "Sinon Monastery", latitude: 27.3000, longitude: 88.2200 },
  { name: "Sri Badam Monastery", latitude: 27.2700, longitude: 88.1600 },
  { name: "Tashi Samboling Monastery", latitude: 27.2900, longitude: 88.2000 },
  { name: "Enchey Monastery", latitude: 27.3408, longitude: 88.6200 },
  { name: "Lingdok Tsangkhar Monastery", latitude: 27.3150, longitude: 88.5950 },
  { name: "Lachen Ngodub Choling Monastery", latitude: 27.6950, longitude: 88.5450 },
  { name: "Lachen Thangu Monastery", latitude: 27.7500, longitude: 88.5800 },
  { name: "Kagon Tshechhogling Monastery", latitude: 27.2900, longitude: 88.5700 },
  { name: "Ray Mindu Katenling Monastery", latitude: 27.2850, longitude: 88.5550 },
  { name: "Phensang Monastery", latitude: 27.2950, longitude: 88.5750 },
  { name: "Silem Phagyal Tashi Dargyeling Monastery", latitude: 27.8470, longitude: 88.6780 },
  { name: "Phodong Karma Tashi Chokhorling Monastery", latitude: 27.4850, longitude: 88.7180 },
  { name: "Singchit Ngadag Monastery", latitude: 27.2400, longitude: 88.5500 },
  { name: "Linkoed Monastery", latitude: 27.2450, longitude: 88.5650 },
  { name: "Pabyuk Monastery", latitude: 27.2250, longitude: 88.5750 },
  { name: "Tholung Monastery", latitude: 27.6500, longitude: 88.6200 },
  { name: "Choten Monastery", latitude: 27.3200, longitude: 88.5900 },
  { name: "Lingdum Zurmang Kharwang Gonpa Monastery", latitude: 27.3100, longitude: 88.5600 },
  { name: "Raloong Monastery", latitude: 27.2700, longitude: 88.5400 },
  { name: "Sang Ngor Monastery", latitude: 27.2800, longitude: 88.5800 },
  { name: "Sichey Dechen Choling Monastery", latitude: 27.3000, longitude: 88.6100 },
  { name: "Tashi Palden Monastery", latitude: 27.2600, longitude: 88.5550 },
  { name: "Tinkye Gonjang Monastery", latitude: 27.2750, longitude: 88.5750 },
  { name: "Ringyim Rigdzin Tharling Monastery", latitude: 27.6500, longitude: 88.5200 },
  { name: "Gor Rinchen Khando Monastery", latitude: 27.6800, longitude: 88.5500 },
  { name: "Barphog Chhodub Dargyeling Monastery", latitude: 27.7100, longitude: 88.5800 },
  { name: "Shagyong Monastery", latitude: 27.6200, longitude: 88.4800 },
  { name: "Tsawang Choling Monastery", latitude: 27.6600, longitude: 88.5100 },
  { name: "Kabi Sanga Dargyeling Monastery", latitude: 27.6900, longitude: 88.5600 },
  { name: "Sontam Tensung Monastery", latitude: 27.7200, longitude: 88.5900 },
  { name: "Tsungthang Monastery", latitude: 27.6400, longitude: 88.4900 },
  { name: "Tareng Gonpa Dargye Choling Monastery", latitude: 27.7000, longitude: 88.5700 },
  { name: "Martam Namdzong Monastery", latitude: 27.2800, longitude: 88.4200 },
  { name: "Amba Mamring Monastery", latitude: 27.3100, longitude: 88.4500 },
  { name: "Radong Tensung Monastery", latitude: 27.2900, longitude: 88.4800 },
  { name: "Bakcham Monastery", latitude: 27.3200, longitude: 88.5100 },
  { name: "Taktse Ani Gonpa Ugen Chokhorling Monastery", latitude: 27.2700, longitude: 88.4600 },
  { name: "Khatek Pema Choling Monastery", latitude: 27.3300, longitude: 88.5300 },
    { name: "Tekling Dzokchen Monastery", latitude: 27.2100, longitude: 88.3900 },
  { name: "Rolep Monastery", latitude: 27.3400, longitude: 88.5000 },
  { name: "Rongli Monastery", latitude: 27.1800, longitude: 88.7000 },
  { name: "Dzongu Monastery", latitude: 27.5200, longitude: 88.4900 },
  { name: "Samdong Monastery", latitude: 27.3500, longitude: 88.4800 },
  { name: "Mangshila Monastery", latitude: 27.4100, longitude: 88.4700 },
  { name: "Passingdong Monastery", latitude: 27.5300, longitude: 88.5100 },
  { name: "Hee Gyathang Monastery", latitude: 27.2600, longitude: 88.2600 },
  { name: "Soreng Monastery", latitude: 27.1500, longitude: 88.3200 },
  { name: "Kaluk Monastery", latitude: 27.1900, longitude: 88.2600 },
  { name: "Namchi Monastery", latitude: 27.1700, longitude: 88.3600 },
  { name: "Ravangla Monastery", latitude: 27.3100, longitude: 88.3600 },
  { name: "Temi Monastery", latitude: 27.2300, longitude: 88.3700 },
  { name: "Yangang Monastery", latitude: 27.2000, longitude: 88.4200 },
  { name: "Mangan Monastery", latitude: 27.5200, longitude: 88.5300 },
  { name: "Chungthang Monastery", latitude: 27.6100, longitude: 88.6400 },
  { name: "Lachung Monastery", latitude: 27.6900, longitude: 88.7400 },
  { name: "Yumthang Monastery", latitude: 27.8000, longitude: 88.6900 },
  { name: "Ranka Monastery", latitude: 27.3100, longitude: 88.5900 },
  { name: "Pelling Monastery", latitude: 27.3000, longitude: 88.2400 },
  { name: "Yuksom Monastery", latitude: 27.3700, longitude: 88.2200 },
  { name: "Rabdentse Monastery", latitude: 27.3100, longitude: 88.2300 },
  { name: "Dzongri Monastery", latitude: 27.5500, longitude: 88.2000 },
  { name: "Namthang Monastery", latitude: 27.1600, longitude: 88.4300 },
  { name: "Sadam Monastery", latitude: 27.2000, longitude: 88.5000 },
  { name: "Rhenock Monastery", latitude: 27.1700, longitude: 88.8300 },
  { name: "Pakyong Monastery", latitude: 27.2300, longitude: 88.5900 },
  { name: "Melli Monastery", latitude: 27.1100, longitude: 88.4200 },
  { name: "Singtam Monastery", latitude: 27.2300, longitude: 88.5000 },
  { name: "Tumin Monastery", latitude: 27.2800, longitude: 88.6400 },
  { name: "Gangyap Monastery", latitude: 27.3300, longitude: 88.5500 },
  { name: "Lingzya Monastery", latitude: 27.3900, longitude: 88.6100 },
  { name: "Kewzing Monastery", latitude: 27.2800, longitude: 88.3500 },
  { name: "Dentam Monastery", latitude: 27.1900, longitude: 88.1700 },
  { name: "Uttarey Monastery", latitude: 27.3000, longitude: 88.1400 },
  { name: "Bermiok Monastery", latitude: 27.2300, longitude: 88.2500 },
  { name: "Tikjuk Monastery", latitude: 27.6000, longitude: 88.6000 },
  { name: "Toong Monastery", latitude: 27.3400, longitude: 88.5700 },
  { name: "Khamdong Monastery", latitude: 27.3500, longitude: 88.5000 },
  { name: "Singhik Monastery", latitude: 27.5100, longitude: 88.5000 },
  { name: "Lingthem Monastery", latitude: 27.5500, longitude: 88.5600 },
  { name: "Shipgyer Monastery", latitude: 27.4800, longitude: 88.6200 },
  { name: "Tumlong Monastery", latitude: 27.4700, longitude: 88.5400 },
  { name: "Phensong Monastery", latitude: 27.3200, longitude: 88.5800 },
  { name: "Rakdong Monastery", latitude: 27.2700, longitude: 88.5200 }
];

export function findMonasteryCoordinates(monasteryName) {
  const entry = monasteryCoordinates.find(
    m => m.name.toLowerCase() === monasteryName.toLowerCase()
  );
  return entry ? { lat: entry.latitude, lon: entry.longitude } : null;
}
